import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = true, roles = null }) {
  const { user } = useAuth();
  if (user === null) {
    return <div className="flex min-h-[50vh] items-center justify-center text-sm" style={{ color: "var(--arc-text-2)" }}>Loading…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles) {
    if (!roles.includes(user.role)) return <Navigate to="/" replace />;
  } else if (adminOnly && user.role !== "admin") {
    return <Navigate to="/" replace />;
  }
  return children;
}
